module.exports = __webpack_public_path__ + "img/horizontal_3_6_8023.a044fb4a.png";